<template>
    <layout>
        <div class="bg-image bg-trees full-height">
            <div :class="[working ? 'block-opt-refresh' : '', 'block', 'block-rounded', 'animated', 'fadeIn', 'centered', 'login']">
                <div class="block-content block-content-full block-content-narrow">
                    <h1 class="h2 font-w600 push-10-t push-20 text-center">
                        <!-- CertPilot -->
                        <img src="../../assets/img/tfs-logo-optimized.jpg" style="width: 75%;">
                    </h1>
                    <form v-on:submit.prevent="attempt" class="form-horizontal push-30-t push-30" novalidate>
                        <wc-input label="Email Address" v-model="email" :neverDirty="true"></wc-input>
                        <wc-input type="password" label="Password" v-model="password" :neverDirty="true" :silent="true"></wc-input>

                        <div class="form-group">
                            <div class="col-xs-12">
                                <label class="css-input switch switch-sm switch-primary">
                                    <input type="checkbox" name="remember"><span></span> Remember Me?
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="hidden" name="_token" value="Gs7rAgsTDA5eqhqQuGz90OR3XiYg4w8t0elDPRqh">
                            <div class="col-xs-12">
                                <button class="btn btn-block btn-primary" type="submit">
                                    Log in
                                </button>
                            </div>
                        </div>
                        <!-- <p class="text-center remove-margin-b">Don't have an account? <router-link to="register">Register Now</router-link></p> -->
                    </form>
                </div>
            </div>
        </div>
    </layout>
</template>


<script>
    import { required, email, minLength } from 'vuelidate/lib/validators';

    export default {
        name: 'login',
        data () {
            return {
                email: '',
                password: '',
                working: false
            };
        },
        components: {
            layout: require('../layouts/blank.vue'),
            wcInput: require('../elements/forms/wc-input.vue')
        },
        methods: {
            attempt () {
                // Trigger validation
                this.$v.$touch();

                // Halt submission if credentials are invalid
                if (this.$v.$invalid) {
                    this.$toasted.error('Please enter a valid email address and password.');
                    return;
                }

                this.working = true;

                // Attempt to authenticate with API
                this.axios.post('auth/token', {
                    'email': this.email,
                    'password': this.password
                })
                .then((response) => {
                    if(!response.data.roles || !response.data.roles.length) {
                        this.working = false;

                        this.$swal({
                            title: `Insufficient Privilege`,
                            text: `Contact admin if you believe this message is in error`,
                            type: "error",
                            confirmButtonText: 'OK',
                        });
                    } else {
                        this.$store.dispatch('auth/login', response.data);
                        this.$router.push('/');
                    }
                })
                .catch((error) => {
                    this.working = false;
                    if (error.response && error.response.status === 401) {
                        this.$toasted.error('Login failed. Please try again.');
                    }
                });
            }
        },
        validations: {
            email: { required, email },
            password: { required, minLength: minLength(6) }
        }
    };
</script>



// WEBPACK FOOTER //
// login.vue?6383a43a